import { Component, inject, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TramiteAbreviacion } from '../../../../models/TramiteAbreviacion';
import { TramiteAbreviacionesService } from '../../../../services/tramite-abreviaciones.service';
import { MatDialog } from '@angular/material/dialog';
import { AppTitleService } from '../../../../services/app-title.service';
import { DlgUpdateTramiteAbreviacionComponent } from '../../../../commons/dlg-update-tramite-abreviacion/dlg-update-tramite-abreviacion.component';
import { DlgDeleteComponent } from '../../../../commons/dlg-delete/dlg-delete.component';
import { ScnackbarData, ToastService, SnackbarStyles } from '../../../../commons/toast.service';
import { MatToolbarModule } from '@angular/material/toolbar';

@Component({
    selector: 'app-tramite-abreviaciones',
    imports: [
        MatTableModule,
        MatButtonModule,
        MatIconModule,
        MatToolbarModule,
        MatTooltipModule
    ],
    templateUrl: './tramite-abreviaciones.component.html',
    styleUrl: './tramite-abreviaciones.component.scss'
})
export class TramiteAbreviacionesComponent implements OnInit {
  abreviaciones: TramiteAbreviacion[] = []

  displayedColumns: string[] = ['depaNombre', 'abreviatura', 'actions'];
  dataSource = new MatTableDataSource<TramiteAbreviacion>([])

  snackbarData: ScnackbarData = {}

  constructor(
    private tramiteAbreviacionesService: TramiteAbreviacionesService,
    public dlg: MatDialog,
    private toast: ToastService
  ) {
    inject(AppTitleService).setTitle("Administraci\xf3n");
  }

  ngOnInit(): void {
    this.fetchTramiteAbreviaciones()
  }

  onAddTramiteAbreviacion() {
    const dialogRef = this.dlg.open(DlgUpdateTramiteAbreviacionComponent, {
      maxWidth: "50vw",
      width: "500px",
      autoFocus: false,
    })
    dialogRef.afterClosed().subscribe((result: TramiteAbreviacion | null) => {
      if (result) {
        this.fetchTramiteAbreviaciones()
      }
    });
  }

  onUpdateTramiteAbreviacion(abreviacion: TramiteAbreviacion) {
    const dialogRef = this.dlg.open(DlgUpdateTramiteAbreviacionComponent, {
      maxWidth: "50vw",
      width: "500px",
      autoFocus: false,
      data: abreviacion
    })
    dialogRef.afterClosed().subscribe((result: TramiteAbreviacion | null) => {
      if (result) {
        this.fetchTramiteAbreviaciones()
      }
    });
  }

  onDeleteTramiteAbreviacion(id: number) {
    const dlgDelete = this.dlg.open(DlgDeleteComponent, {
      width: '350px',
    });

    dlgDelete.afterClosed().subscribe(result => {
      if (result === 1) {
        this.tramiteAbreviacionesService.deleteTramiteAbreviacion(id).subscribe({
          next: (_) => {
            this.snackbarData.message = "Abreviación trámite eliminada!"
            this.snackbarData.style = SnackbarStyles.Success
            this.snackbarData.iconName = "check_circle"
            this.toast.show(this.snackbarData)
            this.fetchTramiteAbreviaciones()
          },
          error: (_) => {
            this.snackbarData.message = "Error eliminando abreviación trámite!"
            this.snackbarData.style = SnackbarStyles.Error
            this.snackbarData.iconName = "error"
            this.toast.show(this.snackbarData)
            this.fetchTramiteAbreviaciones()
          }
        })
      }
    });
  }

  fetchTramiteAbreviaciones() {
    this.tramiteAbreviacionesService.listTramiteAbreviaciones().subscribe({
      next: (response) => {
        this.abreviaciones = response
        this.dataSource!.data = this.abreviaciones
      }
    })
  }

}
